import { write, utils } from "xlsx";
import XLSXStyle from "xlsx-js-style";
import FileSaver from "file-saver";

const EXCEL_TYPE =
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

export const exportJSONToExcel = (data, headers, title, author, sheetName) => {
	const workBook = utils.book_new();
	workBook.Props = {
		Title: title,
		Author: author,
		CreatedDate: new Date()
	};

	workBook.SheetNames.push(sheetName);

	const workSheet = utils.json_to_sheet(data, headers);
	workBook.Sheets[sheetName] = workSheet;

	const excelBuffer = write(workBook, { bookType: "xlsx", type: "array" });

	saveAsExcel(excelBuffer, title);
};

const saveAsExcel = (buffer, fileName) => {
	const data = new Blob([buffer], { type: EXCEL_TYPE });
	FileSaver.saveAs(data, `${fileName}.xlsx`);
};

// Igual que exportJSONToExcel, pero permite asignar estilos por celda.
// getCellStyle(row, header) debe regresar un objeto de estilo de xlsx-js-style o undefined.
export const exportJSONToExcelConEstilos = (data, headers, title, author, sheetName, getCellStyle) => {
	const workBook = XLSXStyle.utils.book_new();
	workBook.Props = {
		Title: title,
		Author: author,
		CreatedDate: new Date()
	};

	const workSheet = XLSXStyle.utils.json_to_sheet(data, headers);

	data.forEach((row, rowIndex) => {
		headers.header.forEach((header, colIndex) => {
			const style = getCellStyle(row, header);
			if (!style) return;

			// +1 por la fila de encabezados
			const cellRef = XLSXStyle.utils.encode_cell({ r: rowIndex + 1, c: colIndex });
			if (!workSheet[cellRef]) workSheet[cellRef] = { t: "s", v: "" };
			workSheet[cellRef].s = style;
		});
	});

	XLSXStyle.utils.book_append_sheet(workBook, workSheet, sheetName);

	const excelBuffer = XLSXStyle.write(workBook, { bookType: "xlsx", type: "array" });

	saveAsExcel(excelBuffer, title);
};
